// extracted by mini-css-extract-plugin
export default {"root":"UnderwritingSidebar_root__qab1C","selected":"UnderwritingSidebar_selected__96CQg","extraWidth":"UnderwritingSidebar_extraWidth__FPiqf"};